// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userTable_root__2FGJZ {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 0px;\n  border-radius: 15px;\n  min-height: 250px;\n  height: calc(100vh - 240px);\n  overflow: hidden;\n  background: #fff;\n  position: relative;\n  overflow: auto; }\n  .userTable_root__2FGJZ .userTable_wrapper__1TZ2G {\n    display: flex;\n    flex-direction: column;\n    height: 250px;\n    overflow: auto; }\n\n.userTable_loaderContainer__zlUZn {\n  position: absolute;\n  left: calc(50% - 20px);\n  top: calc(50% - 20px);\n  z-index: 100; }\n", ""]);
// Exports
exports.locals = {
	"root": "userTable_root__2FGJZ",
	"wrapper": "userTable_wrapper__1TZ2G",
	"loaderContainer": "userTable_loaderContainer__zlUZn"
};
module.exports = exports;
